import { styled } from "styled-components";

export const ListContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ListWrapper = styled.div`
  width: 100%;
  background-color: #ffffff;
  box-shadow: 2px 2px 10px #888888;
  border-radius: 15px;
  padding: 15px 20px;
  margin: 0 5px;
`;

export const ListLine = styled.div`
  border-bottom: 1px solid #888888b9;
  margin: 10px 0;
`;
